import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useDialogExpansionContext } from '../../dialog-expansion-context';
import { useQuery } from '../../query-context';

/**
 * The idea of this component is to trigger the fetch of certain bundles which
 * must be available only after the query is entered.
 * This ensures that bundles are loaded only when the user has a high chances of interacting with them i.e. once the user has gone past prequery phase.
 * This preloading ensures that there is no jank when the user interacts with these components.
 */

export var AsyncLoadOnQuery = function AsyncLoadOnQuery() {
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetched = _useState2[0],
    setIsFetched = _useState2[1];
  useEffect(function () {
    if (query && isFetched === false && isExpanded) {
      import( /* webpackPrefetch: true */
      /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/smart-user-filter/smart-user-picker" */'@atlaskit/smart-user-picker');
      import( /* webpackPrefetch: true */
      /* webpackChunkName: "@atlaskit-internal_@atlassian/search-dialog/show-more/select" */'@atlaskit/select/AsyncSelect');
      setIsFetched(true);
    }
  }, [query, isFetched, setIsFetched, isExpanded]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};